// removed by extract-text-webpack-plugin
module.exports = {"root":"profile--root--fMvpomxe","info":"profile--info--3FWc1C2d","actions":"profile--actions--1VsJypXw"};


//////////////////
// WEBPACK FOOTER
// ./views/users/profile/styles.css
// module id = ./views/users/profile/styles.css
// module chunks = 0